import { WifiOff, RefreshCw } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

// Full page offline component
export function OfflinePage({ onRetry }) {
  const { isDark } = useTheme();
  
  return (
    <div className={`min-h-screen flex flex-col items-center justify-center p-6 ${isDark ? 'bg-[#080D1A]' : 'bg-gray-50'}`}>
      <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 ${
        isDark ? 'bg-white/10' : 'bg-gray-200'
      }`}>
        <WifiOff className={`w-10 h-10 ${isDark ? 'text-white/60' : 'text-gray-400'}`} />
      </div>
      
      <h2 className={`font-display text-xl mb-2 text-center ${isDark ? 'text-white' : 'text-gray-900'}`}>
        Sei offline
      </h2>
      
      <p className={`text-center mb-6 ${isDark ? 'text-white/60' : 'text-gray-500'}`}>
        Controlla la tua connessione internet e riprova
      </p>
      
      {onRetry && (
        <button 
          onClick={onRetry}
          className="btn-primary flex items-center gap-2"
        >
          <RefreshCw className="w-4 h-4" />
          Riprova
        </button>
      )}
    </div>
  );
}

// Inline offline message for sections
export function OfflineMessage({ message = "Contenuto non disponibile offline" }) {
  const { isDark } = useTheme();
  
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-4 ${
        isDark ? 'bg-white/10' : 'bg-gray-100'
      }`}>
        <WifiOff className={`w-7 h-7 ${isDark ? 'text-white/50' : 'text-gray-400'}`} />
      </div>
      <p className={`text-center ${isDark ? 'text-white/60' : 'text-gray-500'}`}>
        {message}
      </p>
    </div>
  );
}

// Top banner for offline status
export function OfflineBanner() {
  const { isDark } = useTheme();
  
  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 px-4 flex items-center justify-center gap-2 ${
        isDark ? 'bg-[#F59E0B]' : 'bg-[#F59E0B]'
      }`}
      style={{
        paddingTop: 'calc(env(safe-area-inset-top, 0px) + 8px)',
        paddingBottom: '8px',
      }}
    >
      <WifiOff className="w-4 h-4 text-white" />
      <span className="text-white text-sm font-medium">Sei offline</span>
    </div>
  );
}
